<template>
  <div>
    <div id="header-container" class="px-5">
      <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header" />
      <div class="pt-4 text-white mb-4">
        <h3 class="text-white">{{ $t("Consolidation Form") }}</h3>
        <span class="fz-16 fw-400">{{
          $t("Fill in the form to initiate a fund consolidation")
          }}</span>
      </div>
    </div>
    <b-container fluid class="mt-0 pb-5">
      <div id="body-container">
        <b-row>
          <b-col cols="12">
            <h4 class="pl-3 pt-3">{{ $t("Consolidate Information") }}</h4>
          </b-col>
        </b-row>
        <b-row>
          <!-- <b-col cols="12">
                        <label>{{ $t('Recipient Number') }} <span class="text-danger">*</span></label>
                        <input type="text" v-model="user_no" name="user_no" value="" :placeholder="$t('User Number')" class="form-control mb-3">
                    </b-col> -->
          <b-col cols="6">
            <div class="form-group mb-3">
              <label>{{ $t("User Number") }}
                <span class="text-danger">*</span></label>
              <Select2 v-model="user_no" :options="usernoList" @select="onSelectUser($event)" :settings="{
                escapeMarkup: doEscapeMarkup,
                placeholder: $t('Recipient'),
              }" class="form-control" />
              <div v-if="error['user_no']" class="invalid-feedback d-block mb-3">
                {{ $t(error["user_no"]) }}
              </div>
            </div>
          </b-col>
          <b-col cols="6">
            <div class="form-group mb-3">
              <label>{{ $t("Recipient") }} <span class="text-danger">*</span></label>
              <div class="d-flex align-items-center">
                <div class="flex-grow-1 overflow-hidden">
                  <Select2 v-model="recipient" :options="payeeList" @select="onSelectRecipient($event)" :settings="{
                    escapeMarkup: doEscapeMarkup,
                    placeholder: $t('Recipient'),
                  }" class="form-control" />
                </div>
                <!-- <button
                  class="btn btn-primary ml-2 flex-shrink-0"
                  @click="addRecipient"
                >
                  + Add Recipient
                </button> -->
              </div>
              <div v-if="error['recipient']" class="invalid-feedback d-block mb-3">
                {{ $t(error["recipient"]) }}
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <div class="form-group mb-3">
              <label>{{ $t("Select Currency") }}
                <span class="text-danger">*</span></label>
              <select class="form-control" @change="onChangeUserCurrency" v-model="code">
                <option value="">-- Select Currency --</option>
                <optionUserCurrency v-if="user_currency.length > 0" v-for="item in user_currency"
                  :mapping_currency="mapping_currency" :notzero="true" :userNo="user_no" :currency="item" :key="item">
                </optionUserCurrency>
              </select>
              <div v-if="error.code" class="invalid-feedback d-block">
                {{ $t(error.code) }}
              </div>
            </div>
          </b-col>
          <b-col cols="6">
            <div class="form-group mb-3">
              <label>{{ $t("Amount") }}<span class="text-danger">*</span></label>
              <MaskAmount @set-price="changePrice($event)" :bus="transfer"></MaskAmount>
              <div v-if="error.amount" class="invalid-feedback d-block mb-3">
                {{
                  $t(error.amount, {
                    amount: this.minimum_amount,
                    currency: code,
                  })
                }}
              </div>
            </div>
          </b-col>
        </b-row>
        <!-- <b-row>
                    <b-col cols="6">
                        <div class="block-item px-2 py-4 text-center">
                            <label class="w-100 fz-20 fw-600 text-grey7 mb-2">{{ $t('Transfer Fee {percentage}',{percentage:fee}) }}</label>
                            <div class="fz-36 fw-600">{{ getResult(amount*fee/100) }}</div>
                        </div>
                    </b-col>
                    <b-col cols="6">
                        <div class="form-group mb-3">
                            <div class="block-item px-2 py-4 text-center">
                                <label class="w-100 fz-20 fw-600 text-grey7 mb-2">{{ $t('Total') }}</label>
                                <div class="fz-36 fw-600">{{ getResult(amount*fee/100) }}</div>
                            </div>
                            <div v-if="currency==1" class="text-muted fz-14 ml-auto">{{ $t('Approximately') }} ~{{ code }} {{ this.approximately }}</div>
                        </div>
                    </b-col>
                </b-row> -->
        <b-row>
          <b-col cols="12" class="text-right mb-3">
            <button class="btn btn-primary" @click="onSubmit">
              {{ $t("Submit") }}
            </button>
          </b-col>
        </b-row>
      </div>
    </b-container>

    <b-modal id="modal-confirmation" size="md" hide-header hide-footer>
      <div class="text-center">
        <img :src="`${publicPath}/img/gep/icon/summary.svg`" class="icon-summary mb-2" />
        <div class="text-grey7 fz-18 fw-700 mb-2">Consolidate Amount</div>
      </div>
      <div class="fz-36 fw-600 text-center mb-3">
        {{ code }} {{ getPrince(amount + fee) }}
      </div>
      <hr class="dashed" />
      <div class="d-flex flex-column px-3">
        <div class="d-flex mb-3">
          <span class="text-grey7 fz-16 w-100">Payment Time</span>
          <span class="ml-auto fw-600 w-100">{{ getDate() }}</span>
        </div>
        <div class="d-flex mb-3">
          <span class="text-grey7 fz-16 w-100">Payment Method</span>
          <span class="ml-auto fw-600 w-100">Consolidate</span>
        </div>
        <div class="d-flex mb-3">
          <span class="text-grey7 fz-16 w-100">Recipient Name</span>
          <span class="ml-auto fw-600 w-100">{{ recipientName }}</span>
        </div>
        <div class="d-flex mb-3">
          <span class="text-grey7 fz-16 w-100">Recipient Number</span>
          <span class="ml-auto fw-600 w-100">{{ recipient }}</span>
        </div>
      </div>
      <hr class="dashed" />
      <div class="d-flex flex-column px-3">
        <div class="d-flex mb-3">
          <span class="text-grey7 fz-16 w-100">Amount</span>
          <span class="ml-auto fw-600 w-100">{{ code }} {{ getPrince(amount) }}</span>
        </div>
        <div class="d-flex mb-3">
          <span class="text-grey7 fz-16 w-100">Processing Fee</span>
          <span class="ml-auto fw-600 w-100">{{ code }} {{ getPrince(fee) }}</span>
        </div>
        <div class="d-flex mb-3">
          <span class="text-grey7 fz-16 w-100">Total</span>
          <span class="ml-auto fw-600 w-100">{{ code }} {{ getPrince(amount + fee) }}</span>
        </div>
      </div>
      <hr class="dashed" />
      <div class="text-small text-center text-grey7 mb-5">
        Are you sure you want to continue the transfer process? Click
        <b>'Yes, Proceed'</b> to continue the process, and click <b>‘No’</b> to
        return to the previous page.
      </div>
      <div class="d-flex">
        <button class="btn btn-secondary w-100" @click="$bvModal.hide('modal-confirmation')">
          No
        </button>
        <button class="btn btn-primary w-100" @click="doSubmit">Yes</button>
      </div>
    </b-modal>

    <b-modal id="complete-transfer" title="CompleteMessage" size="sm" @hide="onHideModal" hide-header hide-footer>
      <b-row class="d-flex justify-content-center complete-card">
        <b-col sm="12" md="6" class="my-4 text-center">
          <svg width="100" height="100" class="checklist-complete">
            <circle fill="#f8c617" stroke="none" stroke-width="10" cx="50" cy="50" r="46.5" class="circle"
              stroke-linecap="round" />
            <polyline fill="none" stroke="#fff" stroke-width="6" points="22,53.5 43,71 76,33" stroke-linecap="round"
              stroke-linejoin="round" class="tick" />
          </svg>
        </b-col>
        <b-col sm="12" md="9" class="my-4 text-center">
          <h1>{{ $t("Thank You!") }}</h1>
          <div class="mt-3 mb-4">
            {{ $t("Your request has been submitted,") }}<br />
            {{ $t("Our team will review the submission request.") }}
          </div>
          <button @click="onHideModal" class="btn btn-primary text-white">
            {{ $t("OK") }}
          </button>
        </b-col>
      </b-row>
    </b-modal>

    <LoaderComponent v-if="isLoading"></LoaderComponent>
  </div>
</template>
<script>
import moment from "moment";
import Vue from "vue";
import LoaderComponent from "@/components/LoaderComponent";
import Select2 from "v-select2-component";
import MaskAmount from "@/components/Mask/MaskAmount";
import CurrencyService from "@/services/CurrencyService";
import Account from "@/services/Account";
import CreateAccount from "@/services/CreateAccount";
import optionUserCurrency from "@/components/optionUserCurrency";

import Global from "@/services/Global";
import confetti from "@/assets/js/confetti.js";

export default {
  name: "account-opening",
  data() {
    return {
      publicPath: process.env.BASE_URL != "/" ? process.env.BASE_URL : "",
      isLoading: false,
      transfer: new Vue(),
      code: "",
      amount: 0,
      fee: 0,
      approximately: 0,
      rate: 0,
      recipient: "",
      user_no: "",
      userReqNo: "",
      recipientName: "",
      payeeList: [],
      usernoList: [],
      currency_list: [],
      mapping_currency: {},
      minimum_amount: process.env.VUE_APP_MINIMUM_TRANSFER,
      stepList: ["Transfer Information", "Transfer Summary"],
      user_currency: [],
      currency: process.env.VUE_APP_CURRENCY,
      error: {
        amount: "",
        code: "",
      },
    };
  },
  components: {
    LoaderComponent,
    MaskAmount,
    Select2,
    optionUserCurrency,
  },
  methods: {
    getDate() {
      return moment().format("DD-MM-YYYY H:mm:ss");
    },
    onChangeUserCurrency() {
      this.error.code = "";
    },
    getPrince(price) {
      return Global.addCommas(price);
    },
    onSelectUser({ id, text, currency }) { },
    onSelectRecipient({ id, text }) {
      this.recipientName = text;
    },
    doEscapeMarkup(markup) {
      return markup;
    },
    onHideModal() {
      this.$router.push({
        path: "/transfer-summary",
        query: {
          user_no: this.user_no,
          recipient: this.recipient,
          recipientName: this.recipientName,
          user_req_no: this.userReqNo,
        },
      });
    },
    onSubmit() {
      this.$bvModal.show("modal-confirmation");
    },
    doSubmit() {
      const params = {
        userNo: this.user_no,
        payerAmt: this.amount,
        payerCcy: this.code,
        payeeUserNo: this.recipient,
      };

      this.$bvModal.hide("modal-confirmation");
      this.isLoading = true;

      Account.transfer(params)
        .then((response) => {
          if (response.status == 200) {
            this.isLoading = false;
            this.userReqNo = response.data.data.userReqNo;
            this.$bvModal.show("complete-transfer");
          }
        })
        .catch((err) => {
          this.checkError(err);
        });
    },
    checkError(err) {
      try {
        this.isLoading = false;
        const response = err.response;
        if (response.status == 400) {
          const data = response.data.data.response;
          if (data["errorMsg"]) {
            this.$notify({
              type: "warn",
              text: data["errorMsg"],
            });
          } else if (typeof data === "string") {
            this.$notify({
              type: "warn",
              text: data,
            });
          } else {
            let ret = [];
            Object.keys(data).forEach((key) => {
              ret.push(data[key][0]);
            });

            this.$notify({
              type: "warn",
              html: ret.join("<br>"),
            });
          }
        } else if (
          response.status == 401 &&
          response.data.name == "Unauthorized"
        ) {
          localStorage.removeItem("token");
          localStorage.removeItem("member");
          localStorage.removeItem("isFirstTime");
          this.$router.push({
            path: "/login",
          });
        } else {
          if (localStorage.getItem("token")) {
            var msg = response.data ? response.data.message : err.message;
            this.$notify({
              type: "warn",
              text: msg,
            });
          }
        }
      } catch (e) {
        console.log(err);
      }
    },
    getSubAccount(item) {
      let self = this;
      CreateAccount.listSubAccount({
        start: 0,
        length: -1,
        search: { value: item.userNo },
      }).then((response) => {
        if (response.status == 200) {
          if (response.data.data.length > 0) {
            let sub_account = response.data.data[0];
            // self.status = STATUS[this.sub_account.status];
            // self.balance = this.sub_account['currency'].split(",");
            self.user_currency = sub_account["currency"].split(",");

            let text = sub_account.accountName
              ? sub_account.accountName + " - "
              : "";
            text += item.userNo;
            self.usernoList.push({
              id: item.userNo,
              text: text,
              currency: item.currency,
            });
            self.user_no = self.usernoList[0].id;
          } else {
            self.status =
              this.item.status != 2 ? STATUS[this.item.status] : STATUS[1];
          }
        }
      });
    },
    loadData() {
      let self = this;
      this.usernoList = [];
      CreateAccount.list({
        start: 0,
        length: -1,
      }).then((response) => {
        if (response.status == 200) {
          const data = response.data.data[0];
          self.getSubAccount(data);
        }
      });

      this.payeeList = [];
      Account.listPayee().then((response) => {
        if (response.status == 200) {
          const data = response.data.data;

          data.forEach(function (item) {
            let text = item.accountName ? item.accountName + " - " : "";
            text += item.relationship_userNo;
            self.payeeList.push({ id: item.relationship_userNo, text: text });
          });

          this.recipient = data.relationship_userNo;
          this.recipientName = data.accountName;
        }
      });
    },
    currencyLoad() {
      CurrencyService.get(this.code).then((response) => {
        if (response.status == 200) {
          const data = response.data.response.list;
          if (data) {
            this.rate = parseFloat(data[0].rate);
            this.approximately = this.getResult(
              (this.amount + (this.amount * this.fee) / 100) * this.rate
            );
          }
        }
      });
    },
    changePrice(event) {
      this.error.amount = "";
      this.amount = event;
      if (this.amount < parseFloat(this.minimum_amount)) {
        this.error.amount = "Minimum Amount is {currency} {amount}";
      } else if (this.amount < 0) {
        this.error.amount = "Please enter a sufficient amount";
      }

      this.approximately = this.getResult(
        (this.amount + (this.amount * this.fee) / 100) * this.rate
      );
    },
    onChange(name) {
      if (name == "code") {
        this.currencyLoad();
      }
      this.error[name] = "";
    },
    getResult(amount) {
      if (amount > 0) {
        return parseFloat(amount).toFixed(2);
      } else {
        return 0;
      }
    },
    addRecipient() {
      this.$router.push({
        path: "/add-recipient",
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      CreateAccount.listCurrency().then((response) => {
        this.mapping_currency = response.data;
      });

      let currency = localStorage.getItem("ccy");
      if (currency) {
        this.currency_list = JSON.parse(currency);
      } else {
        this.currency_list = ["HKD"];
      }
      this.code = this.currency_list[0];
      this.currencyLoad();
      this.loadData();
    });
  },
};
</script>

<style>
.dashed {
  border-top: 2px dashed #d1d4d7;
}

.icon-summary {
  border-radius: 20px;
  background: #edf8f1;
}

.overflow-hidden {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
